module.exports = __webpack_public_path__ + "static/assets/e8cd6294973f94c475ed746e4899fa33.svg";